// src/components/hospitalizacion/RegistroModal.jsx
import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  Typography,
  Alert,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box, Tabs, Tab, 
} from '@mui/material';
import { Save, Close, Info } from '@mui/icons-material';
import api from '../../api/api';
import dayjs from 'dayjs';

const RegistroModal = ({ open, onClose, hospitalizacionId, onSave }) => {
  const [tabValue, setTabValue] = useState(0); // 0 = Evolución, 1 = Balance Hídrico
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Estados para Evolución (ya los tenías)
  const [temperatura, setTemperatura] = useState('');
  const [fc, setFc] = useState('');
  const [fr, setFr] = useState('');
  const [spo2, setSpo2] = useState('');
  const [paSistolica, setPaSistolica] = useState('');
  const [paDiastolica, setPaDiastolica] = useState('');
  const [pam, setPam] = useState('');
  const [crt, setCrt] = useState('');
  const [mucosas, setMucosas] = useState('');
  const [scoreDolor, setScoreDolor] = useState('');
  const [glucosa, setGlucosa] = useState('');
  const [lactato, setLactato] = useState('');
  const [pesoActual, setPesoActual] = useState('');
  const [diuresisMlKgH, setDiuresisMlKgH] = useState('');
  const [actitud, setActitud] = useState('');
  const [emesisCount, setEmesisCount] = useState('0');
  const [deposiciones, setDeposiciones] = useState('');
  const [apetito, setApetito] = useState('');
  const [observacionesEvol, setObservacionesEvol] = useState('');

// Estados Balance Hídrico Centralizado
const [categoria, setCategoria] = useState('plan_infusion'); // 'plan_infusion', 'ingreso', 'egreso'
const [tipoFluido, setTipoFluido] = useState(''); // Ej: Ringer (Plan/Ingreso) u Orina (Egreso)
const [volumenReal, setVolumenReal] = useState(''); // Para ingresos/egresos reales
const [viaOrigen, setViaOrigen] = useState(''); // Vía para ingresos, Origen para egresos
const [aditivos, setAditivos] = useState('');
const [ritmoMlH, setRitmoMlH] = useState('');
const [volumenObjetivo, setVolumenObjetivo] = useState('');
const [observacionesBalance, setObservacionesBalance] = useState('');

// ==================== ESTADOS PARA MEDICACIÓN (nueva pestaña) ====================
  const [medicamento, setMedicamento] = useState('');
  const [principioActivo, setPrincipioActivo] = useState('');
  const [dosisValor, setDosisValor] = useState('');
  const [dosisUnidad, setDosisUnidad] = useState('');
  const [viaMedicacion, setViaMedicacion] = useState('');
  const [frecuenciaHoras, setFrecuenciaHoras] = useState('');
  const [esInfusionContinua, setEsInfusionContinua] = useState(false);
  const [ritmoInfusion, setRitmoInfusion] = useState('');
  const [indicacionMedicacion, setIndicacionMedicacion] = useState('');
  const [fechaInicioMedicacion, setFechaInicioMedicacion] = useState(dayjs().format('YYYY-MM-DD'));
  const [fechaFinMedicacion, setFechaFinMedicacion] = useState('');
  const [estadoMedicacion, setEstadoMedicacion] = useState('activo'); // Valor por defecto
  const [horaInicioMedicacion, setHoraInicioMedicacion] = useState(dayjs().format('HH:mm'));

  // ==================== ESTADOS PARA NUTRICIÓN (nueva pestaña) ====================
const [alimento, setAlimento] = useState('');
const [cantidadOfrecida, setCantidadOfrecida] = useState('');
const [consumoPorcentaje, setConsumoPorcentaje] = useState('');
const [viaNutricion, setViaNutricion] = useState('oral'); // oral, sonda, parenteral, etc.
const [tipoIngesta, setTipoIngesta] = useState('voluntaria'); // voluntaria, forzada, sonda
const [rechazo, setRechazo] = useState('');
//const [rechazoMotivo, setRechazoMotivo] = useState('');
const [notasNutricion, setNotasNutricion] = useState('');
//const [observacionesNutricion, setObservacionesNutricion] = useState('');
const [kcalEstimadas, setKcalEstimadas] = useState('');

// ==================== ESTADOS PARA ACCESOS INVASIVOS (nueva pestaña) ====================
const [tipoDispositivo, setTipoDispositivo] = useState('');
const [calibre, setCalibre] = useState('');
const [sitioAnatomico, setSitioAnatomico] = useState('');
const [lado, setLado] = useState(''); // Derecho/Izquierdo
const [fechaInstalacion, setFechaInstalacion] = useState(dayjs().format('YYYY-MM-DDTHH:mm'));
const [observacionesAcceso, setObservacionesAcceso] = useState('');

  


  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleGuardar = async () => {
    if (!hospitalizacionId) {
      setError('No se encontró la hospitalización');
      return;
    }

    setLoading(true);
    setError('');

    try {
      if (tabValue === 0) {
        // Guardar Evolución
        const payloadEvol = {
          id_hospitalizacion: hospitalizacionId,
          fecha_hora: dayjs().format('YYYY-MM-DDTHH:mm:ss'),
          //fecha_hora: dayjs().toISOString(),
          temperatura: temperatura ? parseFloat(temperatura) : null,
          fc: fc ? parseInt(fc) : null,
          fr: fr ? parseInt(fr) : null,
          spo2: spo2 ? parseFloat(spo2) : null,
          pa_sistolica: paSistolica ? parseInt(paSistolica) : null,
          pa_diastolica: paDiastolica ? parseInt(paDiastolica) : null,
          pam: pam ? parseInt(pam) : null,
          crt: crt ? parseFloat(crt) : null,
          mucosas: mucosas || null,
          score_dolor: scoreDolor ? parseInt(scoreDolor) : null,
          glucosa: glucosa ? parseInt(glucosa) : null,
          lactato: lactato ? parseFloat(lactato) : null,
          peso_actual: pesoActual ? parseFloat(pesoActual) : null,
          diuresis_ml_kg_h: diuresisMlKgH ? parseFloat(diuresisMlKgH) : null,
          actitud: actitud || null,
          emesis_count: emesisCount ? parseInt(emesisCount) : 0,
          deposiciones: deposiciones || null,
          apetito: apetito || null,
          observaciones: observacionesEvol.trim() || null,
        };

        await api.post('/hospitalizacion-evolucion/', payloadEvol);

        // Limpiar formulario de evolución
        setTemperatura('');
        setFc('');
        setFr('');
        setSpo2('');
        setPaSistolica('');
        setPaDiastolica('');
        setPam('');
        setCrt('');
        setMucosas('');
        setScoreDolor('');
        setGlucosa('');
        setLactato('');
        setPesoActual('');
        setDiuresisMlKgH('');
        setActitud('');
        setEmesisCount('0');
        setDeposiciones('');
        setApetito('');
        setObservacionesEvol('');
        setEsInfusionContinua(false);

      } else if (tabValue === 1) {
          // Validaciones básicas
          if (!tipoFluido.trim()) {
              setError('El tipo de fluido/sustancia es obligatorio');
              setLoading(false);
              return;
          }

          const payloadBalance = {
            id_hospitalizacion: hospitalizacionId,
            categoria: categoria, // 'plan_infusion', 'ingreso' o 'egreso'
            tipo_fluido: tipoFluido.trim(),
            via_origen: viaOrigen.trim() || null,
            // IMPORTANTE: Si es plan, el volumen real es null hasta que se finalice
            volumen_real: (categoria === 'plan_infusion') ? null : (volumenReal ? parseFloat(volumenReal) : 0),
            aditivos: categoria === 'plan_infusion' ? (aditivos.trim() || null) : null,
            ritmo_ml_h: categoria === 'plan_infusion' ? (ritmoMlH ? parseFloat(ritmoMlH) : null) : null,
            volumen_total_objetivo: categoria === 'plan_infusion' ? (volumenObjetivo ? parseFloat(volumenObjetivo) : null) : null,
            estado: (categoria === 'plan_infusion') ? "activo" : "terminado", 
            observaciones: observacionesBalance.trim() || null,
          };

          await api.post('/hospitalizacion-fluidos/', payloadBalance);

          // Limpiar estados de balance
          setCategoria('plan_infusion');
          setTipoFluido('');
          setVolumenReal('');
          setViaOrigen('');
          setAditivos('');
          setRitmoMlH('');
          setVolumenObjetivo('');
          setObservacionesBalance('');
      } else if (tabValue === 2) {
          if (!medicamento.trim()) {
            setError('El medicamento es obligatorio');
            setLoading(false);
            return;
          }

          const errorFecha = validarFechas();
            if (errorFecha) {
              setError(errorFecha);
              setLoading(false);
              return;
            }

          const fechaHoraCombinada = dayjs(`${fechaInicioMedicacion} ${horaInicioMedicacion}`);
            

          const payloadMedicacion = {
  id_hospitalizacion: hospitalizacionId,
  medicamento: medicamento.trim(),
  principio_activo: principioActivo.trim() || null,
  dosis_valor: dosisValor ? parseFloat(dosisValor) : null,
  dosis_unidad: dosisUnidad.trim() || null,
  via: viaMedicacion.trim() || null,
  // Si frecuencia es 0 o vacío, enviamos 0 explícitamente para indicar dosis única
  frecuencia_horas: frecuenciaHoras ? parseInt(frecuenciaHoras) : 0, 
  es_infusion_continua: esInfusionContinua,
  ritmo_infusion: ritmoInfusion.trim() || null,
  indicacion: indicacionMedicacion.trim() || null,
  fecha_inicio: fechaHoraCombinada.format('YYYY-MM-DDTHH:mm:ss'),
  fecha_fin: fechaFinMedicacion ? dayjs(fechaFinMedicacion).format('YYYY-MM-DDTHH:mm:ss') : null,
  estado: estadoMedicacion,
};   

        await api.post('/tratamientos/', payloadMedicacion);

        // Limpiar medicación
        setMedicamento('');
        setPrincipioActivo('');
        setDosisValor('');
        setDosisUnidad('');
        setViaMedicacion('');
        setFrecuenciaHoras('');
        setEsInfusionContinua(false);
        setRitmoInfusion('');
        setIndicacionMedicacion('');
        setFechaInicioMedicacion(dayjs().format('YYYY-MM-DD'));
        setHoraInicioMedicacion(dayjs().format('HH:mm'));
        setFechaFinMedicacion('');
        setEstadoMedicacion('activo');
      } else if (tabValue === 3) {
              // Nutrición / Alimentación
              if (!alimento.trim()) {
                setError('El alimento o fórmula es obligatorio');
                setLoading(false);
                return;
              }

              const payloadNutricion = {
                id_hospitalizacion: hospitalizacionId,
                fecha_hora: dayjs().toISOString(),
                alimento: alimento.trim(),
                cantidad_ofrecida: cantidadOfrecida ? String(cantidadOfrecida).trim() : null,  // ← Siempre string
                consumo_porcentaje: consumoPorcentaje ? parseInt(consumoPorcentaje) : null,
                kcal_estimadas: kcalEstimadas ? parseInt(kcalEstimadas) : null,              // ← NUEVO
                //kcal_estimadas: null,  // Puedes calcularlo después o dejarlo opcional
                via_administracion: viaNutricion.trim() || 'voluntaria',
                tipo_ingesta: tipoIngesta.trim() || null,
                rechazo: rechazo.trim() || null,                                             // ← NUEVO
                notas: notasNutricion.trim() || null,
                //rechazo_motivo: rechazoMotivo.trim() || null,
                //observaciones: observacionesNutricion.trim() || null,
              };

              await api.post('/nutricion-hospitalaria/', payloadNutricion);

              // Limpiar nutrición
              setAlimento('');
              setCantidadOfrecida('');
              setConsumoPorcentaje('');
              setViaNutricion('oral');
              setTipoIngesta('voluntaria');
              setKcalEstimadas('');      // ← NUEVO
              setRechazo('');            // ← NUEVO
              setNotasNutricion('');
            }  else if (tabValue === 4) {
                  // Accesos Invasivos
                  if (!tipoDispositivo.trim()) {
                    setError('El tipo de dispositivo es obligatorio');
                    setLoading(false);
                    return;
                  }

                  const payloadAcceso = {
                    id_hospitalizacion: hospitalizacionId,
                    tipo_dispositivo: tipoDispositivo.trim(),
                    calibre: calibre.trim() || null,
                    sitio_anatomico: sitioAnatomico.trim() || null,
                    lado: lado.trim() || null,
                    fecha_instalacion: fechaInstalacion ? dayjs(fechaInstalacion).toISOString() : dayjs().toISOString(),
                    estado: 'activo', // por defecto al instalar
                    observaciones: observacionesAcceso.trim() || null,
                  };

                  await api.post('/accesos-invasivos/', payloadAcceso);

                  // Limpiar accesos
                  setTipoDispositivo('');
                  setCalibre('');
                  setSitioAnatomico('');
                  setLado('');
                  setFechaInstalacion(dayjs().format('YYYY-MM-DDTHH:mm'));
                  setObservacionesAcceso('');
                }

      onSave?.();
      onClose();
    } catch (err) {
      console.error('Error al guardar:', err);
      const mensaje = err.response?.data?.detail?.[0]?.msg || err.response?.data?.detail || err.message || 'Error al registrar';
      setError(mensaje);
    } finally {
      setLoading(false);
    }
  };

// --- 1. FUNCIÓN DE RESUMEN MEJORADA ---
const calcularResumen = () => {
  const f = parseInt(frecuenciaHoras);
  const d = dosisValor;
  const u = dosisUnidad || '';

  // CASO DOSIS ÚNICA (Frecuencia 0 o vacía)
  if (f === 0 || !frecuenciaHoras) {
    if (!d) return "Se registrará como una dosis única.";
    return `Se registrará una dosis única de ${d}${u}.`;
  }

  if (isNaN(f) || f < 0) return null;

  const numDosis = Math.floor(24 / f);
  
  if (!d) return `Se programará una dosis cada ${f} horas.`;

  if (numDosis === 0) {
    return "Frecuencia mayor a 24h: se registrará como dosis única/inicial.";
  }
  
  return `Se programarán automáticamente ${numDosis} dosis de ${d}${u} (una cada ${f} horas) para las próximas 24h.`;
};

const horaAmPm = dayjs(`${fechaInicioMedicacion} ${horaInicioMedicacion}`).format('hh:mm A');
const resumen = frecuenciaHoras && horaInicioMedicacion 
  ? `La primera dosis será a las ${horaAmPm}. ${calcularResumen()}` 
  : calcularResumen();
//const resumen = frecuenciaHoras && horaInicioMedicacion  ? `La primera dosis será a las ${horaInicioMedicacion}. ${calcularResumen()}`  : calcularResumen();
// --- 2. VALIDACIÓN DE FECHAS (Para usar en el handleGuardar) ---
const validarFechas = () => {
  if (fechaFinMedicacion && dayjs(fechaFinMedicacion).isBefore(dayjs(fechaInicioMedicacion))) {
    return "La fecha de fin no puede ser anterior a la fecha de inicio.";
  }
  return null;
};
  

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      sx={{ '& .MuiDialog-paper': { borderRadius: 3 } }}
    >
      <DialogTitle sx={{ bgcolor: '#1e293b', color: 'white', py: 2 }}>
        <Typography variant="h6">Registrar Actividad Clínica</Typography>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 3 }}>
        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}

        {/* Pestañas */}
        <Tabs value={tabValue} onChange={handleTabChange} variant="fullWidth" sx={{ mb: 3 }}>
          <Tab label="Evolución / Vitales" />
          <Tab label="Balance Hídrico" />
          <Tab label="Medicación / Tratamiento" />
          <Tab label="Nutrición / Alimentación" />
          <Tab label="Accesos Invasivos" />
          {/* Aquí puedes agregar más pestañas después */}
        </Tabs>

{tabValue === 0 && (
        <Grid container spacing={3}>
          {/* Primera fila: Temperatura, FC, FR */}
          <Grid item xs={12} sm={4}>
            <TextField
              label="Temperatura (°C)"
              type="number"
              fullWidth
              value={temperatura}
              onChange={(e) => setTemperatura(e.target.value)}
              inputProps={{ step: '0.1', min: 30, max: 43 }}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              label="FC (lpm)"
              type="number"
              fullWidth
              value={fc}
              onChange={(e) => setFc(e.target.value)}
              inputProps={{ min: 40, max: 300 }}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              label="FR (rpm)"
              type="number"
              fullWidth
              value={fr}
              onChange={(e) => setFr(e.target.value)}
              inputProps={{ min: 10, max: 100 }}
              variant="outlined"
            />
          </Grid>

          {/* Segunda fila: SpO2, PAM, CRT */}
          <Grid item xs={12} sm={4}>
            <TextField
              label="SpO₂ (%)"
              type="number"
              fullWidth
              value={spo2}
              onChange={(e) => setSpo2(e.target.value)}
              inputProps={{ min: 70, max: 100 }}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              label="PAM (mmHg)"
              type="number"
              fullWidth
              value={pam}
              onChange={(e) => setPam(e.target.value)}
              inputProps={{ min: 40, max: 150 }}
              variant="outlined"
            />
          </Grid>


                    <Grid item xs={12} sm={4}>
            <TextField
              label="PaSistolica"
              type="number"
              fullWidth
              value={paSistolica}
              onChange={(e) => setPaSistolica(e.target.value)}
              inputProps={{ min: 40, max: 150 }}
              variant="outlined"
            />
          </Grid>
                    <Grid item xs={12} sm={4}>
            <TextField
              label="PaDiastolica"
              type="number"
              fullWidth
              value={paDiastolica}
              onChange={(e) => setPaDiastolica(e.target.value)}
              inputProps={{ min: 40, max: 150 }}
              variant="outlined"
            />
          </Grid>




          <Grid item xs={12} sm={4}>
            <TextField
              label="CRT (segundos)"
              type="number"
              fullWidth
              value={crt}
              onChange={(e) => setCrt(e.target.value)}
              inputProps={{ step: '0.1', min: 0, max: 10 }}
              variant="outlined"
            />
          </Grid>

          {/* Tercera fila: Mucosas, Score Dolor, Glucosa */}
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth variant="outlined">
              <InputLabel>Mucosas</InputLabel>
              <Select
                value={mucosas}
                onChange={(e) => setMucosas(e.target.value)}
                label="Mucosas"
              >
                <MenuItem value="">No evaluado</MenuItem>
                <MenuItem value="rosadas">Rosadas</MenuItem>
                <MenuItem value="pálidas">Pálidas</MenuItem>
                <MenuItem value="cianóticas">Cianóticas</MenuItem>
                <MenuItem value="ictéricas">Ictéricas</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              label="Score Dolor (0-10)"
              type="number"
              fullWidth
              value={scoreDolor}
              onChange={(e) => setScoreDolor(e.target.value)}
              inputProps={{ min: 0, max: 10 }}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              label="Glucosa (mg/dL)"
              type="number"
              fullWidth
              value={glucosa}
              onChange={(e) => setGlucosa(e.target.value)}
              inputProps={{ min: 0, max: 600 }}
              variant="outlined"
            />
          </Grid>

          {/* Cuarta fila: Lactato, Peso Actual, Diuresis */}
          <Grid item xs={12} sm={4}>
            <TextField
              label="Lactato (mmol/L)"
              type="number"
              fullWidth
              value={lactato}
              onChange={(e) => setLactato(e.target.value)}
              inputProps={{ step: '0.1', min: 0, max: 20 }}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              label="Peso Actual (kg)"
              type="number"
              fullWidth
              value={pesoActual}
              onChange={(e) => setPesoActual(e.target.value)}
              inputProps={{ step: '0.1', min: 0 }}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              label="Diuresis (ml/kg/h)"
              type="number"
              fullWidth
              value={diuresisMlKgH}
              onChange={(e) => setDiuresisMlKgH(e.target.value)}
              inputProps={{ step: '0.1', min: 0 }}
              variant="outlined"
            />
          </Grid>

          {/* Quinta fila: Actitud, Emesis, Deposiciones, Apetito */}
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth variant="outlined">
              <InputLabel>Actitud</InputLabel>
              <Select
                value={actitud}
                onChange={(e) => setActitud(e.target.value)}
                label="Actitud"
              >
                <MenuItem value="">No evaluada</MenuItem>
                <MenuItem value="alerta">Alerta</MenuItem>
                <MenuItem value="deprimida">Deprimida</MenuItem>
                <MenuItem value="letárgica">Letárgica</MenuItem>
                <MenuItem value="estuporosa">Estuporosa</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Emesis (número)"
              type="number"
              fullWidth
              value={emesisCount}
              onChange={(e) => setEmesisCount(e.target.value)}
              inputProps={{ min: 0 }}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Deposiciones"
              fullWidth
              value={deposiciones}
              onChange={(e) => setDeposiciones(e.target.value)}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth variant="outlined">
              <InputLabel>Apetito</InputLabel>
              <Select
                value={apetito}
                onChange={(e) => setApetito(e.target.value)}
                label="Apetito"
              >
                <MenuItem value="">No evaluado</MenuItem>
                <MenuItem value="normal">Normal</MenuItem>
                <MenuItem value="disminuido">Disminuido</MenuItem>
                <MenuItem value="anorexia">Anorexia</MenuItem>
                <MenuItem value="aumentado">Aumentado</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* Observaciones */}
          <Grid item xs={12}>
            <TextField
              label="Observaciones / Hallazgos clínicos"
              multiline
              rows={4}
              fullWidth
              value={observacionesEvol}
              onChange={(e) => setObservacionesEvol(e.target.value)}
              variant="outlined"
              placeholder="Detalles adicionales, actitud, mucosas, etc..."
            />
          </Grid>
        </Grid>
)}

        {tabValue === 1 && (
  <Grid container spacing={2}>
    {/* Selector de Categoría Principal */}
    <Grid item xs={12}>
      <FormControl fullWidth>
        <InputLabel>¿Qué vas a registrar?</InputLabel>
        <Select
          value={categoria}
          label="¿Qué vas a registrar?"
          onChange={(e) => {
            const nuevaCat = e.target.value;
            setCategoria(nuevaCat);
            // Limpiamos campos cruzados para evitar enviar basura
            setVolumenReal('');
            setRitmoMlH('');
            setVolumenObjetivo('');
          }}
          sx={{ bgcolor: '#f8fafc', fontWeight: 'bold' }}
        >
          <MenuItem value="plan_infusion">Plan de Infusión (Sueros/Goteos)</MenuItem>
          <MenuItem value="ingreso">Ingreso Manual (Agua, Alimento, Bolo IV)</MenuItem>
          <MenuItem value="egreso">Egreso (Orina, Vómito, Drenaje)</MenuItem>
        </Select>
      </FormControl>
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        label={categoria === 'egreso' ? "Tipo de Egreso" : "Tipo de Fluido"}
        fullWidth
        required
        value={tipoFluido}
        onChange={(e) => setTipoFluido(e.target.value)}
        placeholder={categoria === 'egreso' ? "Ej: Orina, Sangre" : "Ej: Ringer, Agua"}
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        label={categoria === 'egreso' ? "Origen" : "Vía"}
        fullWidth
        value={viaOrigen}
        onChange={(e) => setViaOrigen(e.target.value)}
        placeholder={categoria === 'egreso' ? "Ej: Sonda, Pañal" : "Ej: IV, Oral"}
      />
    </Grid>

    {/* Campos dinámicos según categoría */}
    {categoria !== 'plan_infusion' ? (
      <Grid item xs={12}>
        <TextField
          label="Volumen Real (ml)"
          type="number"
          fullWidth
          value={volumenReal}
          onChange={(e) => setVolumenReal(e.target.value)}
          sx={{ bgcolor: '#f0fdf4' }}
        />
      </Grid>
    ) : (
      <>
        <Grid item xs={12} sm={4}>
          <TextField label="Aditivos" fullWidth value={aditivos} onChange={(e) => setAditivos(e.target.value)} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField label="Ritmo (ml/h)" type="number" fullWidth value={ritmoMlH} onChange={(e) => setRitmoMlH(e.target.value)} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField label="Vol. Objetivo (ml)" type="number" fullWidth value={volumenObjetivo} onChange={(e) => setVolumenObjetivo(e.target.value)} />
        </Grid>
      </>
    )}

    <Grid item xs={12}>
      <TextField
        label="Observaciones"
        multiline rows={2} fullWidth
        value={observacionesBalance}
        onChange={(e) => setObservacionesBalance(e.target.value)}
      />
    </Grid>
  </Grid>
)}


{/* Pestaña 2: Medicación (nueva) */}
        {tabValue === 2 && (
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Medicamento *"
                fullWidth
                required
                value={medicamento}
                onChange={(e) => setMedicamento(e.target.value)}
                placeholder="Ej: Ceftriaxona, Metoclopramida"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="Principio Activo"
                fullWidth
                value={principioActivo}
                onChange={(e) => setPrincipioActivo(e.target.value)}
                placeholder="Ej: Ceftriaxona sódica"
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                label="Dosis Valor"
                type="number"
                fullWidth
                value={dosisValor}
                onChange={(e) => setDosisValor(e.target.value)}
                inputProps={{ step: '0.01', min: 0 }}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel>Unidad</InputLabel>
                <Select
                  value={dosisUnidad}
                  label="Unidad"
                  onChange={(e) => setDosisUnidad(e.target.value)}
                >
                  <MenuItem value="mg">mg</MenuItem>
                  <MenuItem value="ml">ml</MenuItem>
                  <MenuItem value="UI">UI</MenuItem>
                  <MenuItem value="mg/kg">mg/kg</MenuItem>
                  <MenuItem value="ml/kg">ml/kg</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel>Vía</InputLabel>
                <Select
                  value={viaMedicacion}
                  label="Vía"
                  onChange={(e) => setViaMedicacion(e.target.value)}
                >
                  <MenuItem value="IV">IV (Intravenosa)</MenuItem>
                  <MenuItem value="IM">IM (Intramuscular)</MenuItem>
                  <MenuItem value="SC">SC (Subcutánea)</MenuItem>
                  <MenuItem value="PO">PO (Oral)</MenuItem>
                  <MenuItem value="Rectal">Rectal</MenuItem>
                  <MenuItem value="Transdérmica">Transdérmica</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Frecuencia (Horas)"
                type="number"
                fullWidth
                value={frecuenciaHoras}
                onChange={(e) => setFrecuenciaHoras(e.target.value)}
                error={parseInt(frecuenciaHoras) <= 0}
                helperText={parseInt(frecuenciaHoras) <= 0 ? "La frecuencia debe ser mayor a 0" : "Indique cada cuántas horas se debe aplicar"}
              />
              
              {resumen && (
                <Box 
                  sx={{ 
                    mt: 1.5, 
                    p: 1.5, 
                    bgcolor: '#eff6ff', 
                    borderLeft: '4px solid #3b82f6',
                    borderRadius: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                    animation: 'fadeIn 0.3s ease-in'
                  }}
                >
                  <Info sx={{ color: '#3b82f6', fontSize: 20 }} />
                  <Typography variant="body2" sx={{ color: '#1e40af', fontWeight: 500 }}>
                    {resumen}
                  </Typography>
                </Box>
              )}
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>¿Es infusión continua?</InputLabel>
                <Select
                  value={esInfusionContinua ? "si" : "no"} // Convertimos el boolean a string para el Select
                  label="¿Es infusión continua?"
                  onChange={(e) => setEsInfusionContinua(e.target.value === "si")} // Convertimos el string a boolean para el estado
                >
                  <MenuItem value="no">No</MenuItem>
                  <MenuItem value="si">Sí (CRI / Goteo)</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {esInfusionContinua && (
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Ritmo de infusión (ml/h)"
                  type="number"
                  fullWidth
                  value={ritmoInfusion}
                  onChange={(e) => setRitmoInfusion(e.target.value)}
                  inputProps={{ step: '0.1', min: 0 }}
                />
              </Grid>
            )}

            <Grid item xs={12}>
              <TextField
                label="Indicación / Motivo"
                multiline
                rows={2}
                fullWidth
                value={indicacionMedicacion}
                onChange={(e) => setIndicacionMedicacion(e.target.value)}
                placeholder="Ej: Control de infección bacteriana, antiemético post-vómitos..."
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="Fecha de Inicio"
                type="date"
                fullWidth
                value={fechaInicioMedicacion}
                onChange={(e) => setFechaInicioMedicacion(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="Hora de Primera Aplicación"
                type="time"
                fullWidth
                value={horaInicioMedicacion}
                onChange={(e) => setHoraInicioMedicacion(e.target.value)}
                InputLabelProps={{ shrink: true }}
                helperText="A partir de esta hora se calcularán las siguientes dosis"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="Fecha de Fin (opcional)"
                type="date"
                fullWidth
                value={fechaFinMedicacion}
                onChange={(e) => setFechaFinMedicacion(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth variant="outlined">
                <InputLabel sx={{ fontWeight: 'bold', color: '#1e293b' }}>Estado Inicial del Tratamiento</InputLabel>
                <Select
                  value={estadoMedicacion}
                  label="Estado Inicial del Tratamiento"
                  onChange={(e) => setEstadoMedicacion(e.target.value)}
                  sx={{ 
                    bgcolor: '#f8fafc', 
                    fontWeight: 'bold',
                    '& .MuiSelect-select': {
                      color: estadoMedicacion === 'activo' ? 'success.main' : 
                            estadoMedicacion === 'suspendido' ? 'warning.main' : 
                            estadoMedicacion === 'finalizado' ? 'info.main' : 'error.main'
                    }
                  }}
                >
                  <MenuItem value="activo">● ACTIVO (Empezar aplicación de inmediato)</MenuItem>
                  <MenuItem value="suspendido">● SUSPENDIDO (Registrar pero no aplicar aún)</MenuItem>
                  <MenuItem value="finalizado">● FINALIZADO (Registro histórico)</MenuItem>
                  <MenuItem value="cancelado">● CANCELADO (Error de prescripción)</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        )}

        {tabValue === 3 && (
  <Grid container spacing={3}>
    <Grid item xs={12} sm={6}>
      <TextField
        label="Alimento / Fórmula *"
        fullWidth
        required
        value={alimento}
        onChange={(e) => setAlimento(e.target.value)}
        placeholder="Ej: Recovery Diet, Hill's a/d, alimento casero, leche maternizada"
      />
    </Grid>

    <Grid item xs={12} sm={6}>
        <TextField
          label="Cantidad ofrecida (g / ml / uds)"
          fullWidth
          value={cantidadOfrecida}
          onChange={(e) => setCantidadOfrecida(e.target.value)}  // ← permite texto libre
          placeholder="Ej: 200g, 120ml, 1 lata"
          helperText="Incluye unidad si es necesario (se guarda como texto)"
        />
      </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        label="% de consumo"
        type="number"
        fullWidth
        value={consumoPorcentaje}
        onChange={(e) => setConsumoPorcentaje(e.target.value)}
        inputProps={{ min: 0, max: 100, step: 1 }}
        helperText="Porcentaje estimado de lo que realmente consumió"
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <FormControl fullWidth>
        <InputLabel>Vía de administración</InputLabel>
        <Select
          value={viaNutricion}
          label="Vía de administración"
          onChange={(e) => setViaNutricion(e.target.value)}
        >
          <MenuItem value="oral">Oral (voluntaria)</MenuItem>
          <MenuItem value="sonda">Sonda enteral (nasogástrica, esofágica)</MenuItem>
          <MenuItem value="parenteral">Parenteral (IV / TPN)</MenuItem>
          <MenuItem value="mixta">Mixta</MenuItem>
        </Select>
      </FormControl>
    </Grid>

    <Grid item xs={12} sm={6}>
      <FormControl fullWidth>
        <InputLabel>Tipo de ingesta</InputLabel>
        <Select
          value={tipoIngesta}
          label="Tipo de ingesta"
          onChange={(e) => setTipoIngesta(e.target.value)}
        >
          <MenuItem value="voluntaria">Voluntaria</MenuItem>
          <MenuItem value="forzada">Forzada / Asistida</MenuItem>
          <MenuItem value="sonda">Sonda enteral</MenuItem>
          <MenuItem value="parenteral">Parenteral total</MenuItem>
        </Select>
      </FormControl>
    </Grid>

    <Grid item xs={12} sm={6}>
  <TextField
    label="Kcal estimadas"
    type="number"
    fullWidth
    value={kcalEstimadas}
    onChange={(e) => setKcalEstimadas(e.target.value)}
    inputProps={{ min: 0, step: 1 }}
    placeholder="Ej: 120, 250"
    helperText="Calorías aproximadas consumidas"
  />
</Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        label="Motivo de rechazo (si aplica)"
        fullWidth
        value={rechazo}
        onChange={(e) => setRechazo(e.target.value)}
        placeholder="Ej: Rechazó después de 20g, vómito posterior"
      />
    </Grid>

    <Grid item xs={12}>
      <TextField
        label="Notas"
        multiline
        rows={3}
        fullWidth
        value={notasNutricion}
        onChange={(e) => setNotasNutricion(e.target.value)}
        placeholder="Ej: Aceptó bien la primera toma, rechazó la segunda, se le ofreció calentado..."
      />
    </Grid>
  </Grid>
)}

{tabValue === 4 && (
  <Grid container spacing={3}>
    <Grid item xs={12} sm={6}>
      <FormControl fullWidth>
        <InputLabel>Tipo de Dispositivo *</InputLabel>
        <Select
          value={tipoDispositivo}
          label="Tipo de Dispositivo *"
          onChange={(e) => setTipoDispositivo(e.target.value)}
          required
        >
          <MenuItem value="IV periférica">Vía IV periférica</MenuItem>
          <MenuItem value="CVC">Catéter venoso central</MenuItem>
          <MenuItem value="Sonda uretral">Sonda uretral</MenuItem>
          <MenuItem value="Sonda nasogástrica">Sonda nasogástrica</MenuItem>
          <MenuItem value="Tubo torácico">Tubo torácico</MenuItem>
          <MenuItem value="Catéter arterial">Catéter arterial</MenuItem>
          <MenuItem value="Otros">Otros</MenuItem>
        </Select>
      </FormControl>
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        label="Calibre / French"
        fullWidth
        value={calibre}
        onChange={(e) => setCalibre(e.target.value)}
        placeholder="Ej: 22G, 18G, 8Fr, 16Fr"
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        label="Sitio anatómico"
        fullWidth
        value={sitioAnatomico}
        onChange={(e) => setSitioAnatomico(e.target.value)}
        placeholder="Ej: Cefálica derecha, Yugular izquierda, Femoral"
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <FormControl fullWidth>
        <InputLabel>Lado</InputLabel>
        <Select
          value={lado}
          label="Lado"
          onChange={(e) => setLado(e.target.value)}
        >
          <MenuItem value="">No aplica</MenuItem>
          <MenuItem value="derecho">Derecho</MenuItem>
          <MenuItem value="izquierdo">Izquierdo</MenuItem>
        </Select>
      </FormControl>
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        label="Fecha y hora de instalación"
        type="datetime-local"
        fullWidth
        value={fechaInstalacion}
        onChange={(e) => setFechaInstalacion(e.target.value)}
        InputLabelProps={{ shrink: true }}
      />
    </Grid>

    <Grid item xs={12}>
      <TextField
        label="Observaciones / Notas"
        multiline
        rows={3}
        fullWidth
        value={observacionesAcceso}
        onChange={(e) => setObservacionesAcceso(e.target.value)}
        placeholder="Ej: Permeable, buena fijación, sin signos de flebitis..."
      />
    </Grid>
  </Grid>
)}

        





      </DialogContent>
      <DialogActions sx={{ p: 3, bgcolor: '#f5f5f5' }}>
        <Button onClick={onClose} variant="outlined" startIcon={<Close />}>
          Cancelar
        </Button>
        <Button
  onClick={handleGuardar}
  variant="contained"
  color="primary"
  disabled={loading}
  startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <Save />}
>
  {tabValue === 0 ? "Guardar Evolución" :
   tabValue === 1 ? "Registrar Balance" :
   tabValue === 2 ? "Agregar Tratamiento" :
   tabValue === 3 ? "Registrar Nutrición" :
   "Registrar Acceso Invasivo"}
</Button>
      </DialogActions>
    </Dialog>
  );
};

export default RegistroModal;